export const featureFlags = {
  // RolloutFlags
  rolloutIntegratedDocumentVerification: false,
  personalPortfolioMulltiAccountEnrollment: false,
  isUnderMaintenance: false,
  latestStableVersion: '', // Native apps force update flag
  rolloutDisableIraTransfers: false, // FF OFF Deposits Allowed, FF On => Desposits NOT Allowed
  rolloutMin100DepositBrokerage: true, // Set to true to enforce $100 Minimum Deposit for Brokerage Accounts if LD doesnt't load
  rolloutIncodeSdkDocumentVerificationEnrollment: false, // Incode SDK Document Verification Rollout
  rolloutSignInPageRedesign: false, // Sign In Page Redesign Rollout
  rolloutInheritedIraEnrollment: false, // Inherited IRA as Enrollment Rollout
  rolloutCopilotKit: false, // Rollout CopilotKit
  rolloutJointEnrollmentV1: false, // Rollout Joint Enrollment V1
  rolloutJointEnrollmentV2: false, // Rollout Joint Enrollment V2 - New Account Types, check desc in LD
  rolloutConsumerEngagementInsights: false, // Rollout Consumer Engagement Insights Braze
  rolloutPlaidLinkedAccounts: false, // Rollout Plaid Linked Accounts
  rolloutEgwDisclosures: 'default', // Rollout EGW Disclosures Flag
  rolloutEvergreenIntelligenceUiAgentSelector: false, // Rollout Evergreen Intelligence UI Agent Selector
  rolloutReentryV2: false, // Rollout Reentry and SignIn V2
  rolloutEnhanceMultiReenter: false, // Rollout enhance multi reentry
  rolloutJointEnrollmentConfirmInformationV2: false, // Rollout Joint Enrollment Confirm Information V2 - Modal-based editing
  rolloutApexSendWire: false, // Rollout Apex Send Wire Flag
}

export type FeatureFlags = typeof featureFlags
